import  types from './all-mutation-types'
import Vue  from 'vue'
import { MutationTree } from 'vuex/types'
import { IAdministrationState } from './state'
import { AloSejour, getDefaultAloSejour } from '@/models/alo/AloSejour'
import { toNumberDictionary } from '@/utils/groupBy'
import { buildStateItem } from '@/models/alo/StateItem'
import { AloUser, getDefaultAloUser } from '@/models/alo/AloUser'
import { AloCommande, getDefaultAloCommande } from '@/models/alo/AloCommande'
import { AloMailSkin, getDefaultAloMailSkin } from '@/models/alo/AloMailSkin'
import { AloMailTemplate, getDefaultAloMailTemplate } from '@/models/alo/AloMailTemplate'
import { getDefaultAloMailTemplateLg } from '@/models/alo/AloMailTemplateLg'
import { AloPanStatus, getDefaultAloPanStatus } from '@/models/alo/AloPanStatus'




const mutations: MutationTree<IAdministrationState> = {
    
   //////////////////////////////////////////////////////////////////
    // SEJOUR
    /////////////////////////////////////////////////////////////////

    [types.ADM_SEJOUR_REQUEST]: state => {    
        state.sejourStatus = 'Chargement des sejour'
    },
    [types.ADM_SEJOUR_SUCCESS]: (state, sejour:Array<AloSejour>) => {        
        state.sejourDic = {...state.sejourDic, ...toNumberDictionary(sejour,f => f.id,getDefaultAloSejour)}
        state.sejourList = buildStateItem(sejour.map(f => f.id))
        state.sejourStatus = 'Chargement des sejour terminé'
    },
    [types.ADM_SEJOUR_ERROR]: state => {        
        state.sejourStatus = 'Erreur lors du chargement des sejour'
    },
    [types.ADM_SEJOUR_DETAIL_REQUEST]: state => {    
        state.sejourStatus = "Chargement du detail de sejour"
    },
    [types.ADM_SEJOUR_DETAIL_SUCCESS]: (state, sejour:AloSejour) => {        
        Vue.set(state.sejourDic,sejour.id,{...getDefaultAloSejour(),...sejour})
        state.sejourStatus = 'Chargement du detail sejour terminé'
    },
    [types.ADM_SEJOUR_DETAIL_ERROR]: state => {        
        state.sejourStatus = 'Erreur lors du chargement du detail sejour'
    },
    [types.ADM_SEJOUR_SAVE_REQUEST]: state => {    
        state.sejourStatus = "Sauvegarde de sejour"
    },
    [types.ADM_SEJOUR_SAVE_SUCCESS]: (state, sejour:AloSejour) => {        
        Vue.set(state.sejourDic,sejour.id,{...getDefaultAloSejour(),...sejour})
        //si l'id n'est pas dans la liste alors on l'ajoute
        if(state.sejourList.item.findIndex(n => n == sejour.id) == -1) state.sejourList.item.push(sejour.id)
        state.sejourStatus = "Sauvegarde de sejour terminée"
    },
    [types.ADM_SEJOUR_SAVE_ERROR]: state => {        
        state.sejourStatus = "Erreur lors de la sauvegarde de sejour"
    },    
    [types.ADM_SEJOUR_RESET_STATUS]: (state) => {
        state.sejourStatus = ''
    },
    [types.ADM_SEJOUR_DELETE_REQUEST]: state => {    
        state.sejourStatus = "Suppression de sejour"
    },
    [types.ADM_SEJOUR_DELETE_SUCCESS]: (state, sejour:AloSejour) => {        
        const idx = state.sejourList.item.indexOf(sejour.id)
        if(idx > -1) state.sejourList.item.splice(idx ,1)
        delete state.sejourDic[sejour.id]                
        state.sejourStatus = "Suppression de sejour terminée"
    },
    [types.ADM_SEJOUR_DELETE_ERROR]: state => {        
        state.sejourStatus = "Erreur lors de la Suppression de sejour"
    },
    [types.ADM_SEJOUR_UPDATE_LAST_QUERY_DATE]: state => {        
        state.lastSejourQuery = new Date();
    },
    
    
    //////////////////////////////////////////////////////////////////
    // USER
    /////////////////////////////////////////////////////////////////

    [types.ADM_USER_REQUEST]: state => {    
        state.userStatus = 'Chargement des user'
    },
    [types.ADM_USER_SUCCESS]: (state, user:Array<AloUser>) => {        
        state.userDic = {...state.userDic, ...toNumberDictionary(user,f => f.id,getDefaultAloUser)}
        state.userList = buildStateItem(user.map(f => f.id))
        state.userStatus = 'Chargement des user terminé'
    },
    [types.ADM_USER_ERROR]: state => {        
        state.userStatus = 'Erreur lors du chargement des user'
    },
    [types.ADM_USER_DETAIL_REQUEST]: state => {    
        state.userStatus = "Chargement du detail de user"
    },
    [types.ADM_USER_DETAIL_SUCCESS]: (state, user:AloUser) => {        
        Vue.set(state.userDic,user.id,{...getDefaultAloUser(),...user})
        state.userStatus = 'Chargement du detail user terminé'
    },
    [types.ADM_USER_DETAIL_ERROR]: state => {        
        state.userStatus = 'Erreur lors du chargement du detail user'
    },
    [types.ADM_USER_SAVE_REQUEST]: state => {    
        state.userStatus = "Sauvegarde de user"
    },
    [types.ADM_USER_SAVE_SUCCESS]: (state, user:AloUser) => {        
        Vue.set(state.userDic,user.id,{...getDefaultAloUser(),...user})
        //si l'id n'est pas dans la liste alors on l'ajoute
        if(state.userList.item.findIndex(n => n == user.id) == -1) state.userList.item.push(user.id)
        state.userStatus = "Sauvegarde de user terminée"
    },
    [types.ADM_USER_SAVE_ERROR]: state => {        
        state.userStatus = "Erreur lors de la sauvegarde de user"
    },    
    [types.ADM_USER_RESET_STATUS]: (state) => {
        state.userStatus = ''
    },
    [types.ADM_USER_DELETE_REQUEST]: state => {    
        state.userStatus = "Suppression de user"
    },
    [types.ADM_USER_DELETE_SUCCESS]: (state, user:AloUser) => {        
        const idx = state.userList.item.indexOf(user.id)
        if(idx > -1) state.userList.item.splice(idx ,1)
        delete state.userDic[user.id]                
        state.userStatus = "Suppression de user terminée"
    },
    [types.ADM_USER_DELETE_ERROR]: state => {        
        state.userStatus = "Erreur lors de la Suppression de user"
    },

    //////////////////////////////////////////////////////////////////
    // COMMANDE
    /////////////////////////////////////////////////////////////////

    [types.ADM_COMMANDE_REQUEST]: state => {    
        state.commandeStatus = 'Chargement des commande'
    },
    [types.ADM_COMMANDE_SUCCESS]: (state, commande:Array<AloCommande>) => {        
        state.commandeDic = {...state.commandeDic, ...toNumberDictionary(commande,f => f.id,getDefaultAloCommande)}
        state.commandeList = buildStateItem(commande.map(f => f.id))
        state.commandeStatus = 'Chargement des commande terminé'
    },
    [types.ADM_COMMANDE_ERROR]: state => {        
        state.commandeStatus = 'Erreur lors du chargement des commande'
    },
    [types.ADM_COMMANDE_DETAIL_REQUEST]: state => {    
        state.commandeStatus = "Chargement du detail de commande"
    },
    [types.ADM_COMMANDE_DETAIL_SUCCESS]: (state, commande:AloCommande) => {        
        Vue.set(state.commandeDic,commande.id,{...getDefaultAloCommande(),...commande})
        state.commandeStatus = 'Chargement du detail commande terminé'
    },
    [types.ADM_COMMANDE_DETAIL_ERROR]: state => {        
        state.commandeStatus = 'Erreur lors du chargement du detail commande'
    },
    [types.ADM_COMMANDE_SAVE_REQUEST]: state => {    
        state.commandeStatus = "Sauvegarde de commande"
    },
    [types.ADM_COMMANDE_SAVE_SUCCESS]: (state, commande:AloCommande) => {        
        Vue.set(state.commandeDic,commande.id,{...getDefaultAloCommande(),...commande})
        //si l'id n'est pas dans la liste alors on l'ajoute
        if(state.commandeList.item.findIndex(n => n == commande.id) == -1) state.commandeList.item.push(commande.id)
        state.commandeStatus = "Sauvegarde de commande terminée"
    },
    [types.ADM_COMMANDE_SAVE_ERROR]: state => {        
        state.commandeStatus = "Erreur lors de la sauvegarde de commande"
    },    
    [types.ADM_COMMANDE_RESET_STATUS]: (state) => {
        state.commandeStatus = ''
    },
    [types.ADM_COMMANDE_DELETE_REQUEST]: state => {    
        state.commandeStatus = "Suppression de commande"
    },
    [types.ADM_COMMANDE_DELETE_SUCCESS]: (state, commande:AloCommande) => {        
        const idx = state.commandeList.item.indexOf(commande.id)
        if(idx > -1) state.commandeList.item.splice(idx ,1)
        delete state.commandeDic[commande.id]                
        state.commandeStatus = "Suppression de commande terminée"
    },
    [types.ADM_COMMANDE_DELETE_ERROR]: state => {        
        state.commandeStatus = "Erreur lors de la Suppression de commande"
    },
    [types.ADM_COMMANDE_UPDATE_LAST_QUERY_DATE]: state => {        
        state.lastCommandeQuery = new Date();
    },

    //////////////////////////////////////////////////////////////////
    // MAIL_TEMPLATE
    /////////////////////////////////////////////////////////////////

    [types.ADM_MAIL_TEMPLATE_REQUEST]: state => {    
        state.mailTemplateStatus = 'Chargement des mailTemplate'
    },
    [types.ADM_MAIL_TEMPLATE_SUCCESS]: (state, mailTemplate:Array<AloMailTemplate>) => {        
        state.mailTemplateDic = {...state.mailTemplateDic, ...toNumberDictionary(mailTemplate,f => f.id,getDefaultAloMailTemplate)}
        state.mailTemplateList = buildStateItem(mailTemplate.map(f => f.id))
        state.mailTemplateStatus = 'Chargement des mailTemplate terminé'
    },
    [types.ADM_MAIL_TEMPLATE_ERROR]: state => {        
        state.mailTemplateStatus = 'Erreur lors du chargement des mailTemplate'
    },
    [types.ADM_MAIL_TEMPLATE_DETAIL_REQUEST]: state => {    
        state.mailTemplateStatus = "Chargement du detail de mailTemplate"
    },
    [types.ADM_MAIL_TEMPLATE_DETAIL_SUCCESS]: (state, mailTemplate:AloMailTemplate) => {                
        mailTemplate.lgs = mailTemplate.lgs.map(it => {return {...getDefaultAloMailTemplateLg(it.lg),...it}})        
        Vue.set(state.mailTemplateDic,mailTemplate.id,{...getDefaultAloMailTemplate(),...mailTemplate})
        state.mailTemplateStatus = 'Chargement du detail mailTemplate terminé'
    },
    [types.ADM_MAIL_TEMPLATE_DETAIL_ERROR]: state => {        
        state.mailTemplateStatus = 'Erreur lors du chargement du detail mailTemplate'
    },
    [types.ADM_MAIL_TEMPLATE_SAVE_REQUEST]: state => {    
        state.mailTemplateStatus = "Sauvegarde de mailTemplate"
    },
    [types.ADM_MAIL_TEMPLATE_SAVE_SUCCESS]: (state, mailTemplate:AloMailTemplate) => {        
        Vue.set(state.mailTemplateDic,mailTemplate.id,{...getDefaultAloMailTemplate(),...mailTemplate})
        //si l'id n'est pas dans la liste alors on l'ajoute
        if(state.mailTemplateList.item.findIndex(n => n == mailTemplate.id) == -1) state.mailTemplateList.item.push(mailTemplate.id)
        state.mailTemplateStatus = "Sauvegarde de mailTemplate terminée"
    },
    [types.ADM_MAIL_TEMPLATE_SAVE_ERROR]: state => {        
        state.mailTemplateStatus = "Erreur lors de la sauvegarde de mailTemplate"
    },    
    [types.ADM_MAIL_TEMPLATE_RESET_STATUS]: (state) => {
        state.mailTemplateStatus = ''
    },
    [types.ADM_MAIL_TEMPLATE_DELETE_REQUEST]: state => {    
        state.mailTemplateStatus = "Suppression de mailTemplate"
    },
    [types.ADM_MAIL_TEMPLATE_DELETE_SUCCESS]: (state, mailTemplate:AloMailTemplate) => {        
        const idx = state.mailTemplateList.item.indexOf(mailTemplate.id)
        if(idx > -1) state.mailTemplateList.item.splice(idx ,1)
        delete state.mailTemplateDic[mailTemplate.id]                
        state.mailTemplateStatus = "Suppression de mailTemplate terminée"
    },
    [types.ADM_MAIL_TEMPLATE_DELETE_ERROR]: state => {        
        state.mailTemplateStatus = "Erreur lors de la Suppression de mailTemplate"
    },

    //////////////////////////////////////////////////////////////////
    // MAIL_SKIN
    /////////////////////////////////////////////////////////////////

    [types.ADM_MAIL_SKIN_REQUEST]: state => {    
        state.mailSkinStatus = 'Chargement des mailSkin'
    },
    [types.ADM_MAIL_SKIN_SUCCESS]: (state, mailSkin:Array<AloMailSkin>) => {        
        state.mailSkinDic = {...state.mailSkinDic, ...toNumberDictionary(mailSkin,f => f.id,getDefaultAloMailSkin)}
        state.mailSkinList = buildStateItem(mailSkin.map(f => f.id))
        state.mailSkinStatus = 'Chargement des mailSkin terminé'
    },
    [types.ADM_MAIL_SKIN_ERROR]: state => {        
        state.mailSkinStatus = 'Erreur lors du chargement des mailSkin'
    },
    [types.ADM_MAIL_SKIN_DETAIL_REQUEST]: state => {    
        state.mailSkinStatus = "Chargement du detail de mailSkin"
    },
    [types.ADM_MAIL_SKIN_DETAIL_SUCCESS]: (state, mailSkin:AloMailSkin) => {        
        Vue.set(state.mailSkinDic,mailSkin.id,{...getDefaultAloMailSkin(),...mailSkin})
        state.mailSkinStatus = 'Chargement du detail mailSkin terminé'
    },
    [types.ADM_MAIL_SKIN_DETAIL_ERROR]: state => {        
        state.mailSkinStatus = 'Erreur lors du chargement du detail mailSkin'
    },
    [types.ADM_MAIL_SKIN_SAVE_REQUEST]: state => {    
        state.mailSkinStatus = "Sauvegarde de mailSkin"
    },
    [types.ADM_MAIL_SKIN_SAVE_SUCCESS]: (state, mailSkin:AloMailSkin) => {        
        Vue.set(state.mailSkinDic,mailSkin.id,{...getDefaultAloMailSkin(),...mailSkin})
        //si l'id n'est pas dans la liste alors on l'ajoute
        if(state.mailSkinList.item.findIndex(n => n == mailSkin.id) == -1) state.mailSkinList.item.push(mailSkin.id)
        state.mailSkinStatus = "Sauvegarde de mailSkin terminée"
    },
    [types.ADM_MAIL_SKIN_SAVE_ERROR]: state => {        
        state.mailSkinStatus = "Erreur lors de la sauvegarde de mailSkin"
    },    
    [types.ADM_MAIL_SKIN_RESET_STATUS]: (state) => {
        state.mailSkinStatus = ''
    },
    [types.ADM_MAIL_SKIN_DELETE_REQUEST]: state => {    
        state.mailSkinStatus = "Suppression de mailSkin"
    },
    [types.ADM_MAIL_SKIN_DELETE_SUCCESS]: (state, mailSkin:AloMailSkin) => {        
        const idx = state.mailSkinList.item.indexOf(mailSkin.id)
        if(idx > -1) state.mailSkinList.item.splice(idx ,1)
        delete state.mailSkinDic[mailSkin.id]                
        state.mailSkinStatus = "Suppression de mailSkin terminée"
    },
    [types.ADM_MAIL_SKIN_DELETE_ERROR]: state => {        
        state.mailSkinStatus = "Erreur lors de la Suppression de mailSkin"
    },

    //////////////////////////////////////////////////////////////////
    // PAN_STATUS
    /////////////////////////////////////////////////////////////////

    [types.ADM_PAN_STATUS_REQUEST]: state => {    
        state.panStatusStatus = 'Chargement des panStatus'
    },
    [types.ADM_PAN_STATUS_SUCCESS]: (state, panStatus:Array<AloPanStatus>) => {        
        state.panStatusDic = {...state.panStatusDic, ...toNumberDictionary(panStatus,f => f.id,getDefaultAloPanStatus)}
        state.panStatusList = buildStateItem(panStatus.map(f => f.id))
        state.panStatusStatus = 'Chargement des panStatus terminé'
    },
    [types.ADM_PAN_STATUS_ERROR]: state => {        
        state.panStatusStatus = 'Erreur lors du chargement des panStatus'
    },
    [types.ADM_PAN_STATUS_DETAIL_REQUEST]: state => {    
        state.panStatusStatus = "Chargement du detail de panStatus"
    },
    [types.ADM_PAN_STATUS_DETAIL_SUCCESS]: (state, panStatus:AloPanStatus) => {        
        Vue.set(state.panStatusDic,panStatus.id,{...getDefaultAloPanStatus(),...panStatus})
        state.panStatusStatus = 'Chargement du detail panStatus terminé'
    },
    [types.ADM_PAN_STATUS_DETAIL_ERROR]: state => {        
        state.panStatusStatus = 'Erreur lors du chargement du detail panStatus'
    },
    [types.ADM_PAN_STATUS_SAVE_REQUEST]: state => {    
        state.panStatusStatus = "Sauvegarde de panStatus"
    },
    [types.ADM_PAN_STATUS_SAVE_SUCCESS]: (state, panStatus:AloPanStatus) => {        
        Vue.set(state.panStatusDic,panStatus.id,{...getDefaultAloPanStatus(),...panStatus})
        //si l'id n'est pas dans la liste alors on l'ajoute
        if(state.panStatusList.item.findIndex(n => n == panStatus.id) == -1) state.panStatusList.item.push(panStatus.id)
        state.panStatusStatus = "Sauvegarde de panStatus terminée"
    },
    [types.ADM_PAN_STATUS_SAVE_ERROR]: state => {        
        state.panStatusStatus = "Erreur lors de la sauvegarde de panStatus"
    },    
    [types.ADM_PAN_STATUS_RESET_STATUS]: (state) => {
        state.panStatusStatus = ''
    },
    [types.ADM_PAN_STATUS_DELETE_REQUEST]: state => {    
        state.panStatusStatus = "Suppression de panStatus"
    },
    [types.ADM_PAN_STATUS_DELETE_SUCCESS]: (state, panStatus:AloPanStatus) => {        
        const idx = state.panStatusList.item.indexOf(panStatus.id)
        if(idx > -1) state.panStatusList.item.splice(idx ,1)
        delete state.panStatusDic[panStatus.id]                
        state.panStatusStatus = "Suppression de panStatus terminée"
    },
    [types.ADM_PAN_STATUS_DELETE_ERROR]: state => {        
        state.panStatusStatus = "Erreur lors de la Suppression de panStatus"
    },


}

export default mutations